/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_ReplacementInputs */



/**
* | output |
* | --- |
* | "Update Replacement" |
*
* @param {Update_ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_replacement = /** @type {((inputs?: Update_ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour le remplacement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisierungsersatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento sostituzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить замену")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazo de actualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新替换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデートの置き換え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिस्थापन अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualização Substituição")
	return /** @type {LocalizedString} */ ("Update Replacement")
});